import React from "react";
import styled from "styled-components";
import { X } from "lucide-react";

const StyledClearIcon = styled.div`
  cursor: pointer;
  background-color: #0098db;
  border: 0;
  outline: 0;
  padding: 6px;
  position: absolute;
  top: 50%;
  right: 20px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  z-index: 10;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
  width: 28px;
  height: 28px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #0077b3;
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  @media screen and (max-width: 500px) {
    right: 15px;
    width: 24px;
    height: 24px;
    padding: 5px;
  }
`;

const XIcon = styled(X)`
  color: white;
  width: 16px;
  height: 16px;

  @media screen and (max-width: 500px) {
    width: 14px;
    height: 14px;
  }
`;

const ClearIcon = ({ onClick }) => {
  return (
    <StyledClearIcon onClick={onClick}>
      <XIcon />
    </StyledClearIcon>
  );
};

export default ClearIcon;
